export default "__VITE_ASSET__CXDOBo94__"